<template>
  <div class="cashflow-type-income card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-amount="income.recommendedOrExpectedAmount"
                      :recommended-or-expected-label="titles.incomeProgress.recommendedLabel"
                      :up-to-now-label="titles.incomeProgress.actualsLabel"
                      :up-to-now-amount="income.upToNowAmount"
                      :show-warning-if-exceeding-budget="false"
                      :out-of-date="true"/>

    <predicted-category-sections :actuals-title="titles.categorySections.fixedIncome.actualsTitle"
                                 :recommended-title="titles.categorySections.fixedIncome.recommendedTitle"
                                 :categories="income.fixedIncome.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="true"
                                 :title="titles.categorySections.fixedIncome.mainTitle"
                                 :out-of-date="true"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <predicted-transaction class="transaction-details"
                           v-for="transaction in transactions"
                           :predicted-transaction="transaction"
                           :can-edit-category="false"
                           :category-name="fixedCategoryName"
                           v-bind:key="transaction.transactionId">

          </predicted-transaction>
        </div>
      </template>
    </predicted-category-sections>

    <predicted-category-sections :actuals-title="titles.categorySections.variableIncome.actualsTitle"
                                 :recommended-title="titles.categorySections.variableIncome.recommendedTitle"
                                 :categories="income.variableIncome.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="this.isPredictedIncome"
                                 :title="titles.categorySections.variableIncome.mainTitle"
                                 :out-of-date="true"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction class="transaction-details"
                                     v-for="transaction in transactions"
                                     :transaction="transaction"
                                     :can-edit-category="false"
                                     :category-name="variableCategoryName"
                                     v-bind:key="transaction.transactionId">

          </transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import PredictedTransaction from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedTransaction.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Transaction from '../../../generic-components/cashflow-types/cashflow-types-base/Transaction.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';

export default {
  name: 'CashflowTypeIncome',
  mixins: [CashflowAnalytics],
  components: {
    Transaction,
    ExpenseProgress,
    PredictedTransaction,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    ...mapGetters('cashflowView', ['isPredictedIncome']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.income;
    },
    income() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    variableCategoryName() {
      return cashflowViewConsts.CATEGORY_NAMES.VARIABLE_INCOME;
    },
    fixedCategoryName() {
      return cashflowViewConsts.CATEGORY_NAMES.FIXED_INCOME;
    },
    titles() {
      return {
        incomeProgress: {
          actualsLabel: 'נכנס עד עכשיו',
          recommendedLabel: 'סה״כ צפוי להיכנס',
        },
        categorySections: {
          fixedIncome: {
            actualsTitle: 'נכנס',
            recommendedTitle: 'צפוי להיכנס',
            mainTitle: 'פירוט הכנסות קבועות',
          },
          variableIncome: {
            actualsTitle: 'נכנס',
            mainTitle: 'פירוט הכנסות משתנות',
          },
        },
        cardTitle: 'הכנסות',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .out-of-date-cashflow-view-container {
    .cashflow-type-income {
      @include cashflow-card;

      .title {
        color: $riseup_gray_2;
        @include cashflow-card-title;
      }

      .cashflow-type-color {
        color: $riseup_gray_2;
      }

      .cashflow-type-background-color {
        background-color: $riseup_gray_2;
      }
    }
  }

</style>
